import AdvancedSettingService from '../../services/advancedSetting.service';
import i18n from '@/locales/i18n';
import dayjs from 'dayjs';

import { getField, updateField } from 'vuex-map-fields';
import { showSwal } from '../../util/swal';
import { INIT_SETTINGS } from '../../constants/AdvancedSettingConst';
import { getCurrentDevice } from '../../util/checkDevice';

async function getCurrentConnectedCameras() {
	const cameras = await navigator.mediaDevices.enumerateDevices()
	// fitler only videoinput
	let filterCameras = cameras.filter((camera) => camera.kind === 'videoinput');
	// format camera object
	filterCameras = filterCameras.map((camera) => { 
		return {
			value: camera.deviceId,
			text: camera.label,
		};
	});
	return filterCameras
}

export default {
	namespaced: true,

	state() {
		return {
			advancedSetting: INIT_SETTINGS,
			advancedSettingId: null,
			currentConnectedCamera: [],
			device: ''
		};
	},

	actions: {
		/**
		 * get current connected cameras
		 * @returns {Array} cameras
		 */
		async getCurrentConnectedCameras({ commit, state, dispatch }) {
			if(state.device === 'tablet' || state.device === 'mobile') return

			const cameras = await getCurrentConnectedCameras();
			commit('SET_CURRENT_CONNECTED_CAMERAS', { cameras: cameras })
			return cameras
		},
		async saveAdvanceSetting({ commit }, { body, userId }) {
			try {
				const res = await AdvancedSettingService.create({ body, userId });
				console.log({ res });
				if (res && res.status === 200) {
					showSwal({
						type: 'success',
						title: i18n.t('success'),
						text: i18n.t('saveAdvancedSettingSuccess'),
					});
					commit('SET_ADVANCED_SETTING_ID', res.data.advanced_setting_id);
					return;
				}

				showSwal({
					type: 'fail',
					title: i18n.t('fail'),
					text: i18n.t('saveAdvancedSettingFailed'),
				});
			} catch (error) {
				console.log({ error });
				showSwal({
					type: 'fail',
					title: i18n.t('fail'),
					text: i18n.t('saveAdvancedSettingFailed'),
				});
			}
		},
		async editAdvanceSetting({ commit }, { body, userId }) {
			try {
				const res = await AdvancedSettingService.update({ body, userId });
				if (res && res.status === 200) {
					showSwal({
						type: 'success',
						title: i18n.t('success'),
						text: i18n.t('saveAdvancedSettingSuccess'),
					});

					return;
				}

				showSwal({
					type: 'fail',
					title: i18n.t('fail'),
					text: i18n.t('saveAdvancedSettingFailed'),
				});
			} catch (error) {
				console.log({ error });
				showSwal({
					type: 'fail',
					title: i18n.t('fail'),
					text: i18n.t('saveAdvancedSettingFailed'),
				});
			}
		},

		async getByUser({ commit, state, dispatch }, userId) {
			let advancedSetting;
			let stateAdvancedSetting = structuredClone(state.advancedSetting);
			let foundSelectedCamera;

			try {
				const res = await AdvancedSettingService.getByUser({ userId });
				if (!res || res.status !== 200) return;

				advancedSetting = res.data;
			} catch (error) {
				console.log({ error });
			}
			
			if (!advancedSetting?._id) {
				localStorage.setItem(
					'advancedSetting',
					JSON.stringify(structuredClone(INIT_SETTINGS))
				);

				commit('SET_CONTENT_ADVANCE_SETTING', structuredClone(INIT_SETTINGS));
				return;
			}

			commit('SET_ADVANCED_SETTING_ID', advancedSetting?._id);

			// loop through response advancedSetting
			for (let storedSettingsKey in advancedSetting) {
				// loop through current advancedSetting
				for (let localSettingKeys in stateAdvancedSetting) {
					// loop through items
					stateAdvancedSetting[localSettingKeys].map((setting, idx) => {
						if (setting.key === storedSettingsKey) {
							setting.settingContent = advancedSetting[storedSettingsKey];
							if (setting.key === 'selected_camera') {
								foundSelectedCamera = {
									index: idx,
									settingKey: localSettingKeys,
									settingValue: advancedSetting[storedSettingsKey],
								};
							}
						}
					});
				}
			}

			try {
				if (foundSelectedCamera) {
					const cameras = await getCurrentConnectedCameras();
					const found = cameras.find(
						(camera) => camera.value == foundSelectedCamera.settingValue
					);
					if (!found) {
						stateAdvancedSetting[foundSelectedCamera.settingKey][
							foundSelectedCamera.index
						].settingContent = cameras[0].value;
					}
				}
			} catch (error) {
				console.log(error);
			}

			commit('SET_CONTENT_ADVANCE_SETTING', stateAdvancedSetting);
		},

		async getCameraId({ dispatch, state, rootState }) {
			let cameraId = null;
			const cameras = await dispatch('getCurrentConnectedCameras');
			const res = await AdvancedSettingService.getByUser({ userId: rootState.global?.auth?.userInfo?.id });
			if (res && res.status === 200) {
				cameraId = res.data?.selected_camera;
				const found = cameras.find((camera) => camera.value === cameraId);
				if (!found) {
					cameraId = cameras[0].value;
				}
			}
			return cameraId;
		},

		async getCurrentDevice({ commit }) {
			const device = getCurrentDevice()
			commit('SET_DEVICE', device)
		}
	},

	mutations: {
		updateField,
		SET_CONTENT_ADVANCE_SETTING(state, payload) {
			state.advancedSetting = payload;
		},
		SET_ADVANCED_SETTING_ID(state, payload) {
			state.advancedSettingId = payload;
		},
		SET_CURRENT_CONNECTED_CAMERAS(state, payload) { 			
			// ex: payload = {cameras: []}
			state.currentConnectedCamera = payload.cameras;
		},
		SET_DEVICE(state, payload) {
			state.device = payload;
		}
	},

	getters: {
		getField,
	},
};
